import * as i0 from '@angular/core';
import { Component, Input, EventEmitter, Output, ContentChildren, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { SprintStates, CapturumTemplateDirective } from '@capturum/ui/api';
import * as i2 from 'primeng/accordion';
import { AccordionModule } from 'primeng/accordion';
import * as i3 from 'primeng/api';
import { TranslateModule } from '@ngx-translate/core';
function CapturumAccordionComponent_div_1_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵelement(1, "i");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r3.determineColor(tab_r1.headerStatus));
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(tab_r1 == null ? null : tab_r1.headerIcon);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", tab_r1 == null ? null : tab_r1.headerStatus, " ");
  }
}
function CapturumAccordionComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "p-accordionTab", 2);
    i0.ɵɵlistener("onOpen", function CapturumAccordionComponent_div_1_Template_p_accordionTab_onOpen_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.onTabOpen($event));
    });
    i0.ɵɵelementStart(2, "p-header")(3, "div", 3)(4, "div", 4);
    i0.ɵɵtemplate(5, CapturumAccordionComponent_div_1_span_5_Template, 3, 5, "span", 5);
    i0.ɵɵelement(6, "br");
    i0.ɵɵelementStart(7, "span", 6);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelement(9, "div", 7);
    i0.ɵɵelementStart(10, "div", 8);
    i0.ɵɵelementContainer(11, 9);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const tab_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("selected", i_r2 === ctx_r0.activeTab);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", tab_r1.headerStatus);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", tab_r1.header, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", tab_r1 == null ? null : tab_r1.contentTemplate);
  }
}
function CapturumAccordionCardComponent_ng_container_2_i_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i");
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("ac-icon ", ctx_r3.icon, "");
  }
}
function CapturumAccordionCardComponent_ng_container_2_div_5_ng_container_1_i_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 16);
    i0.ɵɵlistener("click", function CapturumAccordionCardComponent_ng_container_2_div_5_ng_container_1_i_1_Template_i_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const action_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r8 = i0.ɵɵnextContext(3);
      action_r6 == null ? null : action_r6.action == null ? null : action_r6.action.call(ctx_r8);
      return i0.ɵɵresetView(ctx_r8.actionClick == null ? null : ctx_r8.actionClick.emit(action_r6 == null ? null : action_r6.key));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMapInterpolate2("ac-action ", action_r6 == null ? null : action_r6.icon, " ", action_r6 == null ? null : action_r6.key, "");
  }
}
function CapturumAccordionCardComponent_ng_container_2_div_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CapturumAccordionCardComponent_ng_container_2_div_5_ng_container_1_i_1_Template, 1, 4, "i", 15);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const action_r6 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.isVisibleAction(action_r6 == null ? null : action_r6.visible));
  }
}
function CapturumAccordionCardComponent_ng_container_2_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, CapturumAccordionCardComponent_ng_container_2_div_5_ng_container_1_Template, 2, 1, "ng-container", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.actions);
  }
}
function CapturumAccordionCardComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 9)(2, "p", 10);
    i0.ɵɵlistener("click", function CapturumAccordionCardComponent_ng_container_2_Template_p_click_2_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r12 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r12.toggleCard(ctx_r12.clickable));
    });
    i0.ɵɵtemplate(3, CapturumAccordionCardComponent_ng_container_2_i_3_Template, 1, 3, "i", 11);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CapturumAccordionCardComponent_ng_container_2_div_5_Template, 2, 1, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.title, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.actions);
  }
}
function CapturumAccordionCardComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headerTemplate);
  }
}
function CapturumAccordionCardComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.isOpen ? ctx_r2.config == null ? null : ctx_r2.config.texts == null ? null : ctx_r2.config.texts.hideText : ctx_r2.config == null ? null : ctx_r2.config.texts == null ? null : ctx_r2.config.texts.showText);
  }
}
const _c0 = function (a0) {
  return {
    "accordion-card__content--open": a0
  };
};
let CapturumAccordionComponent = /*#__PURE__*/(() => {
  class CapturumAccordionComponent {
    constructor() {
      this.activeTab = 0;
    }
    determineColor(headerStatus) {
      switch (headerStatus) {
        case SprintStates.Active:
          return 'warning-color';
        case SprintStates.Finished:
          return 'confirm-color';
        case SprintStates.Planned:
          return 'error-color';
        default:
          return '';
      }
    }
    onTabOpen(event) {
      this.activeTab = event.index;
    }
    static {
      this.ɵfac = function CapturumAccordionComponent_Factory(t) {
        return new (t || CapturumAccordionComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumAccordionComponent,
        selectors: [["cap-accordion"]],
        inputs: {
          accordionTabs: "accordionTabs",
          activeTab: "activeTab"
        },
        decls: 2,
        vars: 4,
        consts: [[3, "activeIndex", "collapseIcon", "expandIcon"], [4, "ngFor", "ngForOf"], [1, "tab", "pt-0", 3, "selected", "onOpen"], [1, "accordion-tab-header-block"], [1, "accordion-tab-header-block-inner"], ["class", "float-md-right status accordion-tab-header-block-text", 3, "ngClass", 4, "ngIf"], [1, "ml-md-1", "accordion-tab-header-block-text"], [1, "dropdown-divider", "p-0"], [1, "px-2", "px-md-3"], [3, "ngTemplateOutlet"], [1, "float-md-right", "status", "accordion-tab-header-block-text", 3, "ngClass"]],
        template: function CapturumAccordionComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "p-accordion", 0);
            i0.ɵɵtemplate(1, CapturumAccordionComponent_div_1_Template, 12, 4, "div", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("activeIndex", ctx.activeTab)("collapseIcon", "fa fa-chevron-down")("expandIcon", "fa fa-chevron-right");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.accordionTabs);
          }
        },
        dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2.Accordion, i2.AccordionTab, i3.Header],
        encapsulation: 2
      });
    }
  }
  return CapturumAccordionComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var AccordionActionVisibility = /*#__PURE__*/function (AccordionActionVisibility) {
  AccordionActionVisibility["always"] = "always";
  AccordionActionVisibility["opened"] = "opened";
  AccordionActionVisibility["closed"] = "closed";
  return AccordionActionVisibility;
}(AccordionActionVisibility || {});
let CapturumAccordionCardComponent = /*#__PURE__*/(() => {
  class CapturumAccordionCardComponent {
    constructor() {
      this.clickable = false;
      this.isOpen = false;
      this.texts = {
        open: 'Show data',
        close: 'Hide data'
      }; // TODO unused
      this.actionClick = new EventEmitter();
      this.onToggle = new EventEmitter();
      this.defaultConfig = {
        texts: {
          showText: 'Show data',
          hideText: 'Hide data'
        },
        openIcon: 'fas fa-chevron-up',
        closeIcon: 'fas fa-chevron-down'
      };
    }
    set config(value) {
      if (value) {
        this.defaultConfig = {
          ...this.defaultConfig,
          ...value
        };
      }
    }
    ngAfterViewInit() {
      this.templates.forEach(template => {
        switch (template.getType()) {
          case 'header':
            this.headerTemplate = template.template;
            break;
          case 'content':
            this.contentTemplate = template.template;
            break;
        }
      });
    }
    toggleCard(clickable) {
      if (clickable) {
        this.isOpen = !this.isOpen;
        this.onToggle.emit(this.isOpen);
      }
    }
    isVisibleAction(visible) {
      switch (visible) {
        case AccordionActionVisibility.always:
          return true;
        case AccordionActionVisibility.closed:
          return this.isOpen === false;
        case AccordionActionVisibility.opened:
          return this.isOpen === true;
      }
    }
    static {
      this.ɵfac = function CapturumAccordionCardComponent_Factory(t) {
        return new (t || CapturumAccordionCardComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumAccordionCardComponent,
        selectors: [["cap-accordion-card"]],
        contentQueries: function CapturumAccordionCardComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, CapturumTemplateDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
          }
        },
        inputs: {
          title: "title",
          icon: "icon",
          clickable: "clickable",
          contentTemplate: "contentTemplate",
          headerTemplate: "headerTemplate",
          actions: "actions",
          isOpen: "isOpen",
          config: "config",
          hideToggle: "hideToggle",
          texts: "texts",
          hideTexts: "hideTexts"
        },
        outputs: {
          actionClick: "actionClick",
          onToggle: "onToggle"
        },
        decls: 11,
        vars: 12,
        consts: [[1, "accordion-card"], [1, "accordion-card__header"], [4, "ngIf"], [3, "ngTemplateOutlet", 4, "ngIf"], [1, "ac-header__right", 3, "click"], [1, "accordion-card__toggler", 3, "click"], [1, "accordion-card__content", 3, "ngClass"], [1, "accordion-card__delimiter"], [3, "ngTemplateOutlet"], [1, "ac-header__left"], [1, "accordion-card__title", 3, "click"], [3, "class", 4, "ngIf"], ["class", "accordion-card__actions", 4, "ngIf"], [1, "accordion-card__actions"], [4, "ngFor", "ngForOf"], [3, "class", "click", 4, "ngIf"], [3, "click"]],
        template: function CapturumAccordionCardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, CapturumAccordionCardComponent_ng_container_2_Template, 6, 3, "ng-container", 2);
            i0.ɵɵtemplate(3, CapturumAccordionCardComponent_ng_container_3_Template, 1, 1, "ng-container", 3);
            i0.ɵɵelementStart(4, "div", 4);
            i0.ɵɵlistener("click", function CapturumAccordionCardComponent_Template_div_click_4_listener() {
              return ctx.toggleCard(ctx.clickable);
            });
            i0.ɵɵelementStart(5, "p", 5);
            i0.ɵɵlistener("click", function CapturumAccordionCardComponent_Template_p_click_5_listener() {
              return ctx.toggleCard(!ctx.clickable);
            });
            i0.ɵɵtemplate(6, CapturumAccordionCardComponent_ng_container_6_Template, 2, 1, "ng-container", 2);
            i0.ɵɵelement(7, "i");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(8, "div", 6);
            i0.ɵɵelement(9, "div", 7);
            i0.ɵɵelementContainer(10, 8);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.headerTemplate);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.headerTemplate);
            i0.ɵɵadvance(1);
            i0.ɵɵstyleProp("visibility", ctx.hideToggle ? "hidden" : "visible");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.hideTexts);
            i0.ɵɵadvance(1);
            i0.ɵɵclassMapInterpolate1("fas ", ctx.isOpen ? (ctx.config == null ? null : ctx.config.openIcon) || "fa-chevron-up" : (ctx.config == null ? null : ctx.config.closeIcon) || "fa-chevron-down", "");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c0, ctx.isOpen));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.contentTemplate);
          }
        },
        dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet],
        encapsulation: 2
      });
    }
  }
  return CapturumAccordionCardComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumAccordionModule = /*#__PURE__*/(() => {
  class CapturumAccordionModule {
    static {
      this.ɵfac = function CapturumAccordionModule_Factory(t) {
        return new (t || CapturumAccordionModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumAccordionModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, AccordionModule, TranslateModule]
      });
    }
  }
  return CapturumAccordionModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AccordionActionVisibility, CapturumAccordionCardComponent, CapturumAccordionComponent, CapturumAccordionModule };
